import React from 'react';

import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import { UiButton } from '@shared/ui/UiButton';

import cls from './FinancialIndicatorsInfoElement.module.css';
import { useFinancialIndicatorsInfoElement } from './useFinancialIndicatorsInfoElement';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';

export enum FinancialInfoType {
    CUSTOMER_DEBT = 'customerDebt',
    BUDGET_SAVED = 'budgetSaved',
    BALANCE_OBJECT = 'balanceObject',
    PROFIT_FORECAST = 'profitForecast',
}

interface FinancialIndicatorsInfoElementProps {
    classes?: string;
    title: string;
    value: string;
    valueSign: string;
    negativeNumber?: boolean;
    positiveNumber?: boolean;
    percentProfit?: number;
    valuePlan?: number;
    percentPlan?: number;
    financialInfoType: FinancialInfoType;
    tooltipText?: string;
}

export const FinancialIndicatorsInfoElement = ({
    classes,
    title,
    value,
    valueSign,
    negativeNumber = false,
    positiveNumber = false,
    financialInfoType,
    percentProfit,
    tooltipText,
    valuePlan,
    percentPlan,
}: FinancialIndicatorsInfoElementProps) => {
    const { onClickReconciliation } = useFinancialIndicatorsInfoElement();
    return (
        <div
            className={classNames(cls.FinancialIndicatorsInfoElement, [classes], {
                [cls.BlockWithoutBorder]: financialInfoType === FinancialInfoType.CUSTOMER_DEBT,
            })}
        >
            <div className={cls.Indicators}>
                <div className={cls.TitleBlock}>
                    <span className={cls.Title}>{title}</span>
                    {financialInfoType !== FinancialInfoType.CUSTOMER_DEBT && (
                        <>
                            <ReactTooltip
                                id={`${financialInfoType}`}
                                aria-haspopup="true"
                                effect="solid"
                                delayHide={200}
                                delayShow={200}
                                type="light"
                                className={cls.tooltip}
                            >
                                <p>{tooltipText}</p>
                            </ReactTooltip>
                            <span className={cls.Icon} data-tip data-for={`${financialInfoType}`}>
                                <Icon iconName="question" />
                            </span>
                        </>
                    )}
                </div>
                <div className={cls.ValueBlock}>
                    <span
                        className={classNames(cls.Value, {
                            [cls.PositiveValue]: positiveNumber,
                            [cls.NegativeValue]: negativeNumber,
                        })}
                    >
                        {value}
                    </span>
                    {financialInfoType === FinancialInfoType.PROFIT_FORECAST && (
                        <span
                            className={classNames(cls.PercentValue, {
                                [cls.NegativePercent]: percentProfit < 0,
                            })}
                        >
                            {numberFormatter.formatNumber(percentProfit)}%
                        </span>
                    )}
                </div>
            </div>
            {financialInfoType === FinancialInfoType.CUSTOMER_DEBT && (
                <UiButton
                    onClick={onClickReconciliation}
                    variant="text"
                    className={cls.finBtn}
                    btnText={i18next.t(
                        'FinancialIndicatorsInfoElement.return.onClickReconciliation'
                    )}
                />
            )}
            {financialInfoType === FinancialInfoType.PROFIT_FORECAST && (
                <div className={cls.ProfitBlock}>
                    <span className={cls.ProfitPlane}>
                        {i18next.t('FinancialIndicatorsInfoElement.return.profitBlock.profitPlane')}
                        {valuePlan}; {percentPlan}%
                    </span>
                </div>
            )}
        </div>
    );
};
